import buildHasuraDataProvider from "ra-data-hasura";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { getApp } from "@firebase/app";
import { getStorage, ref, getDownloadURL, uploadBytes } from "@firebase/storage";
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, concat } from "@apollo/client";

const uploadAndgetImageUrl = async (resource, name, data, storageRef) => {
	const _dataMode = data[name + "__mode__"];
	const _dataImg = data[name + "__img__"];
	const _dataUrl = data[name + "__url__"];

	if (_dataMode === "upload" && typeof _dataImg === "object" && _dataImg.rawFile !== undefined) {
		const fileExtension = _dataImg.rawFile.name.split(".").pop();
		const fileName = `${uuidv4()}.${fileExtension}`;
		const filePath = `${resource}/${name}/${fileName}`;

		await uploadBytes(ref(storageRef, filePath), _dataImg.rawFile);

		const downloadURL = await getDownloadURL(ref(storageRef, filePath));
		return downloadURL;
	}

	return _dataUrl;
};

const getImageUrlAndCleanData = async (resource, name, data, storageRef) => {
	data[name] = await uploadAndgetImageUrl(resource, name, data, storageRef);
	delete data[name + "__mode__"];
	delete data[name + "__img__"];
	delete data[name + "__url__"];
	return data;
};

const handleImageUpload = async (resource, params, storageRef) => {
	let newParams = _.cloneDeep(params);

	if (resource === "campaign") {
		for (const imageField of [
			"abstract_image",
			"background_image",
			"campaign_creator_image",
			"facebook_og_image",
		]) {
			newParams = await getImageUrlAndCleanData(resource, imageField, newParams, storageRef);
		}
	} else if (resource === "challenge") {
		for (const imageField of ["abstract_image", "background_image", "entity_logo"]) {
			newParams = await getImageUrlAndCleanData(resource, imageField, newParams, storageRef);
		}
	}

	return newParams;
};

const httpLink = new HttpLink({ uri: `${process.env.REACT_APP_HASURA_HOSTNAME}/v1/graphql` });

const authMiddleware = new ApolloLink((operation, forward) => {
	// add the authorization to the headers
	operation.setContext(({ headers = {} }) => ({
		headers: {
			...headers,
			authorization: `Bearer ${localStorage.getItem("token") || ""}`,
		},
	}));

	return forward(operation);
});

const createDataProvider = async (initialToken) => {
	const firebaseApp = getApp();
	const firebaseStorage = getStorage(firebaseApp);
	const storageRef = ref(firebaseStorage);

	const myClientWithAuth = new ApolloClient({
		cache: new InMemoryCache(),
		link: concat(authMiddleware, httpLink),
		headers: {
			Authorization: `Bearer ${initialToken || localStorage.getItem("token")}`,
			Accept: "application/json",
			"Content-Type": "application/json",
		},
	});

	const _dataProvider = await buildHasuraDataProvider({
		client: myClientWithAuth,
	});

	const modifiedProvider = {
		..._dataProvider,
		update: async (resource, params) => {
			console.log(resource, params);

			const newData = await handleImageUpload(resource, params.data, storageRef);

			return _dataProvider.update(resource, {
				...params,
				data: newData,
			});
		},
		create: async (resource, params) => {
			console.log(resource, params);
			const newData = await handleImageUpload(resource, params.data, storageRef);

			return _dataProvider.create(resource, {
				...params,
				data: newData,
			});
		},
	};

	return modifiedProvider;
};

export { createDataProvider };
